/**
 * simple props to help add these attributes to your components
 */
export interface DataAttributeProps {
  dataLabel?: string;
  dataPath?: string;
  dataTestId?: string;
}

/**
 * Interface for common data attributes.
 */
export interface DataAttributes {
  'data-label'?: string;
  'data-path'?: string;
  'data-testid'?: string;
}

/**
 * Get a data attributes object that can be spread onto a JSX element as data attribute props.
 * @param props to parse. Undefined values will be ignored.
 * @returns spreadable attribute object.
 */
export function getDataAttributes({ dataLabel, dataPath, dataTestId }: DataAttributeProps): DataAttributes {
  return {
    'data-label': dataLabel,
    'data-path': dataPath,
    'data-testid': dataTestId,
  };
}
